import React, { Fragment, useState, useEffect  } from 'react';
import { actualizarFC_01PaginaActiva } from '../../redux/DucksBeneficiario/FC_01Ducks'
import { actualizarFC_08PaginaActiva } from '../../redux/DucksBeneficiario/FC_08Ducks'
import { actualizarFC_09PaginaActiva } from '../../redux/DucksBeneficiario/FC_09Ducks'
import { actualizarFC_33PaginaActiva } from '../../redux/DucksBeneficiario/FC_33Ducks'
import { actualizarFC_35PaginaActiva } from '../../redux/DucksBeneficiario/FC_35Ducks'
import { actualizarFC_34PaginaActiva } from '../../redux/DucksBeneficiario/FC_34Ducks'
import { actualizarFC_30PaginaActiva } from '../../redux/DucksBeneficiario/FC_30Ducks'
import { actualizarFC_31PaginaActiva } from '../../redux/DucksBeneficiario/FC_31Ducks'
import { actualizarFC_40PaginaActiva } from '../../redux/DucksBeneficiario/FC_40Ducks'
import { actualizarFC_41PaginaActiva } from '../../redux/DucksBeneficiario/FC_41Ducks'
// import { actualizarPaginaActivaFC_01 } from '../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks'
import { actualizarPaginaActivaFC_08 } from '../../redux/DucksAtencionACliente/FC_08AtencionAClienteDucks'
import { actualizarPaginaActivaFC_09 } from '../../redux/DucksAtencionACliente/FC_09AtencionAClienteDucks'
import { actualizarPaginaActivaFC_33 } from '../../redux/DucksAtencionACliente/FC_33AtencionAClienteDucks'
import { actualizarPaginaActivaFC_35 } from '../../redux/DucksAtencionACliente/FC_35AtencionAClienteDucks'
import { actualizarPaginaActivaFC_34 } from '../../redux/DucksAtencionACliente/FC_34AtencionAClienteDucks'
import { actualizarPaginaActivaFC_30 } from '../../redux/DucksAtencionACliente/FC_30AtencionAClienteDucks'
import { actualizarPaginaActivaFC_31 } from '../../redux/DucksAtencionACliente/FC_31AtencionAClienteDucks'
import { actualizarPaginaActivaFC_40 } from '../../redux/DucksAtencionACliente/FC_40AtencionAClienteDucks'
import { actualizarPaginaActivaFC_41 } from '../../redux/DucksAtencionACliente/FC_41AtencionAClienteDucks'
import {
    actualizarFC_36PaginaActiva,
    actualizarFC_36PaginaActivaAlmacen,
    actualizarFC_36PaginaActivaEnvasado,
    actualizarFC_36PaginaActivaProduccion
} from '../../redux/DucksBeneficiario/FC_36Ducks'
import { actualizarPaginaActivaFC_36,
   actualizarPaginaActivaAlmacenFC_36, 
   actualizarPaginaActivaEnvasadoFC_36, 
   actualizarPaginaActivaProduccionFC_36
   } from '../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from './ToolBarPaginas.module.css'

const ToolBarPaginas = (props) => {
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const dispatch = useDispatch()
    const paginas = props.paginas
    const nombreParaPaginas = props.nombreParaPaginas
    const componente = props.componente
    const paginaActiva = useSelector(store => {
        if (tipoUsuario === 3) {
            switch (componente) {
                case 'fc_01':
                    return store.FC_01SolicitudAtencionACliente.paginaActiva
                case 'fc_08':
                    return store.FC_08SolicitudAtencionACliente.paginaActiva
                case 'fc_09':
                    return store.FC_09SolicitudAtencionACliente.paginaActiva
                case 'fc_30':
                    return store.FC_30SolicitudAtencionACliente.paginaActiva
                case 'fc_31':
                    return store.FC_31SolicitudAtencionACliente.paginaActiva
                case 'fc_33':
                    return store.FC_33SolicitudAtencionACliente.paginaActiva
                case 'fc_34':
                    return store.FC_34SolicitudAtencionACliente.paginaActiva
                case 'fc_35':
                    return store.FC_35SolicitudAtencionACliente.paginaActiva
                case 'fc_36':
                    return store.FC_36SolicitudAtencionACliente.paginaActiva
                case 'fc_36Produccion':
                    return store.FC_36SolicitudAtencionACliente.paginaActivaProduccion
                case 'fc_36Envasado':
                    return store.FC_36SolicitudAtencionACliente.paginaActivaEnvasado
                case 'fc_36Almacen':
                    return store.FC_36SolicitudAtencionACliente.paginaActivaAlmacen
                case 'fc_40':
                    return store.FC_40SolicitudAtencionACliente.paginaActiva
                case 'fc_41':
                    return store.FC_41SolicitudAtencionACliente.paginaActiva
                default:
                    return
            }
        } else {
            switch (componente) {
                case 'fc_01':
                    return store.FC_01Solicitud.paginaActiva
                case 'fc_08':
                    return store.FC_08Solicitud.paginaActiva
                case 'fc_09':
                    return store.FC_09Solicitud.paginaActiva
                case 'fc_30':
                    return store.FC_30Solicitud.paginaActiva
                case 'fc_31':
                    return store.FC_31Solicitud.paginaActiva
                case 'fc_33':
                    return store.FC_33Solicitud.paginaActiva
                case 'fc_34':
                    return store.FC_34Solicitud.paginaActiva
                case 'fc_35':
                    return store.FC_35Solicitud.paginaActiva
                case 'fc_36':
                    return store.FC_36Solicitud.paginaActiva
                case 'fc_36Produccion':
                    return store.FC_36Solicitud.paginaActivaProduccion
                case 'fc_36Envasado':
                    return store.FC_36Solicitud.paginaActivaEnvasado
                case 'fc_36Almacen':
                    return store.FC_36Solicitud.paginaActivaAlmacen
                case 'fc_40':
                    return store.FC_40Solicitud.paginaActiva
                case 'fc_41':
                    return store.FC_41Solicitud.paginaActiva
                default:
                    return
            }
        }
    })

    const setPagina = async (target) => {
        if (tipoUsuario === 3) {
            switch (componente) {
                case 'fc_01': {
                    // dispatch(actualizarPaginaActivaFC_01(Number(target.id)))
                    return
                }
                case 'fc_08': {
                    dispatch(actualizarPaginaActivaFC_08(Number(target.id)))
                    return
                }
                case 'fc_09': {
                    dispatch(actualizarPaginaActivaFC_09(Number(target.id)))
                    return
                }
                case 'fc_30': {
                    dispatch(actualizarPaginaActivaFC_30(Number(target.id)))
                    return
                }
                case 'fc_31': {
                    dispatch(actualizarPaginaActivaFC_31(Number(target.id)))
                    return
                }
                case 'fc_33': {
                    dispatch(actualizarPaginaActivaFC_33(Number(target.id)))
                    return
                }
                case 'fc_34': {
                    dispatch(actualizarPaginaActivaFC_34(Number(target.id)))
                    return
                }
                case 'fc_35': {
                    dispatch(actualizarPaginaActivaFC_35(Number(target.id)))
                    return
                }
                case 'fc_36': {
                    dispatch(actualizarPaginaActivaFC_36(Number(target.id)))
                    return
                }
                case 'fc_36Produccion': {
                    dispatch(actualizarPaginaActivaProduccionFC_36(Number(target.id)))
                    return
                }
                case 'fc_36Envasado': {
                    dispatch(actualizarPaginaActivaEnvasadoFC_36(Number(target.id)))
                    return
                }
                case 'fc_36Almacen': {
                    dispatch(actualizarPaginaActivaAlmacenFC_36(Number(target.id)))
                    return
                }
                case 'fc_40': {
                    dispatch(actualizarPaginaActivaFC_40(Number(target.id)))
                    return
                }
                case 'fc_41': {
                    dispatch(actualizarPaginaActivaFC_41(Number(target.id)))
                    return
                }
                default:
                    break;
            }
        } else {
            switch (componente) {
                case 'fc_01': {
                    dispatch(actualizarFC_01PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_08': {
                    dispatch(actualizarFC_08PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_09': {
                    dispatch(actualizarFC_09PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_30': {
                    dispatch(actualizarFC_30PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_31': {
                    dispatch(actualizarFC_31PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_33': {
                    dispatch(actualizarFC_33PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_34': {
                    dispatch(actualizarFC_34PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_35': {
                    dispatch(actualizarFC_35PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_36': {
                    dispatch(actualizarFC_36PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_36Produccion': {
                    dispatch(actualizarFC_36PaginaActivaProduccion(Number(target.id)))
                    return
                }
                case 'fc_36Envasado': {
                    dispatch(actualizarFC_36PaginaActivaEnvasado(Number(target.id)))
                    return
                }
                case 'fc_36Almacen': {
                    dispatch(actualizarFC_36PaginaActivaAlmacen(Number(target.id)))
                    return
                }
                case 'fc_40': {
                    dispatch(actualizarFC_40PaginaActiva(Number(target.id)))
                    return
                }
                case 'fc_41': {
                    dispatch(actualizarFC_41PaginaActiva(Number(target.id)))
                    return
                }
                default:
                    break;
            }
        }
    }

    const botonSiguiente = () => {
        if (tipoUsuario === 3) {
            switch (componente) {
                case 'fc_01':
                    if (paginaActiva < paginas.length) {
                        // dispatch(actualizarPaginaActivaFC_01(paginaActiva + 1))
                    }
                    break;
                case 'fc_08':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_08(paginaActiva + 1))
                    }
                    break;
                case 'fc_09':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_09(paginaActiva + 1))
                    }
                    break;
                case 'fc_30':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_30(paginaActiva + 1))
                    }
                    break;
                case 'fc_31':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_31(paginaActiva + 1))
                    }
                    break;
                case 'fc_33':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_33(paginaActiva + 1))
                    }
                    break;
                case 'fc_34':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_34(paginaActiva + 1))
                    }
                    break;
                case 'fc_35':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_35(paginaActiva + 1))
                    }
                    break;
                case 'fc_36':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_36(paginaActiva + 1))
                    }
                case 'fc_36Produccion':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaProduccionFC_36(paginaActiva + 1))
                    }
                    break;
                case 'fc_36Envasado':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaEnvasadoFC_36(paginaActiva + 1))
                    }
                    break;
                case 'fc_36Almacen':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaAlmacenFC_36(paginaActiva + 1))
                    }
                    break;
                case 'fc_40':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_40(paginaActiva + 1))
                    }
                    break;
                case 'fc_41':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarPaginaActivaFC_41(paginaActiva + 1))
                    }
                    break;
                default:
                    break;
            }
        } else {
            switch (componente) {
                case 'fc_01':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_01PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_08':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_08PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_09':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_09PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_30':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_30PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_31':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_31PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_33':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_33PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_34':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_34PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_35':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_35PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_36':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_36PaginaActiva(paginaActiva + 1))
                    }
                case 'fc_36Produccion':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_36PaginaActivaProduccion(paginaActiva + 1))
                    }
                    break;
                case 'fc_36Envasado':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_36PaginaActivaEnvasado(paginaActiva + 1))
                    }
                    break;
                case 'fc_36Almacen':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_36PaginaActivaAlmacen(paginaActiva + 1))
                    }
                    break;
                case 'fc_40':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_40PaginaActiva(paginaActiva + 1))
                    }
                    break;
                case 'fc_41':
                    if (paginaActiva < paginas.length) {
                        dispatch(actualizarFC_41PaginaActiva(paginaActiva + 1))
                    }
                    break;
                default:
                    break;
            }
        }
    }
    const botonAtras = () => {
        if (tipoUsuario === 3) {
            switch (componente) {
                case 'fc_01':
                    if (paginaActiva > paginas[0]) {
                        // dispatch(actualizarPaginaActivaFC_01(paginaActiva - 1))
                    }
                    break;
                case 'fc_08':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_08(paginaActiva - 1))
                    }
                    break;
                case 'fc_09':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_09(paginaActiva - 1))
                    }
                    break;
                case 'fc_30':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_30(paginaActiva - 1))
                    }
                    break;
                case 'fc_31':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_31(paginaActiva - 1))
                    }
                    break;
                case 'fc_33':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_33(paginaActiva - 1))
                    }
                    break;
                case 'fc_34':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_34(paginaActiva - 1))
                    }
                    break;
                case 'fc_35':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_35(paginaActiva - 1))
                    }
                    break;
                case 'fc_36':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_36(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Produccion':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaProduccionFC_36(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Envasado':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaEnvasadoFC_36(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Almacen':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaAlmacenFC_36(paginaActiva - 1))
                    }
                    break;
                case 'fc_40':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_40(paginaActiva - 1))
                    }
                    break;
                case 'fc_41':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarPaginaActivaFC_41(paginaActiva - 1))
                    }
                    break;
                default:
                    break;
            }
        } else {
            switch (componente) {
                case 'fc_01':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_01PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_08':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_08PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_09':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_09PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_30':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_30PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_31':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_31PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_33':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_33PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_34':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_34PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_35':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_35PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_36':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_36PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Produccion':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_36PaginaActivaProduccion(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Envasado':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_36PaginaActivaEnvasado(paginaActiva - 1))
                    }
                    break;
                case 'fc_36Almacen':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_36PaginaActivaAlmacen(paginaActiva - 1))
                    }
                    break;
                case 'fc_40':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_40PaginaActiva(paginaActiva - 1))
                    }
                    break;
                case 'fc_41':
                    if (paginaActiva > paginas[0]) {
                        dispatch(actualizarFC_41PaginaActiva(paginaActiva - 1))
                    }
                    break;
                default:
                    break;
            }
        }
    }


    const [stickyClass, setStickyClass] = useState('');

    useEffect(() => {
      window.addEventListener('scroll', stickNavbar);
      return () => window.removeEventListener('scroll', stickNavbar);
    }, []);
  
    const stickNavbar = () => {
      if (window !== undefined) {
        let windowHeight = window.scrollY;
        windowHeight > 150 ? setStickyClass(estilos.sticky_nav) : setStickyClass('');
      }
    };

    return (
        <Fragment>
            <div className='container'>
           <nav className={`navbar-nav ${stickyClass}`}>
                    <div className={`row mb-2 mt-2`}>
                        <div className="col-md-12" role="group" aria-label="Paginas">
                            {/* {
                                paginaActiva != 1 ? (
                                    <button
                                        onClick={botonAtras}
                                        className='btn me-2'
                                        style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                    >
                                        Atras
                                    </button>
                                ) :
                                    (
                                        <button
                                            onClick={botonAtras}
                                            className='btn me-2'
                                            style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                            disabled={true}
                                        >
                                            Atras
                                        </button>
                                    )
                            } */}
                            {
                                paginas.map((pag) => (
                                    paginaActiva === pag ? (
                                        <button id={pag} key={pag} type="button" 
                                            // onClick={e => setPagina(e.target)}
                                            style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                            className="btn btn-outline active" >{nombreParaPaginas !== undefined ? nombreParaPaginas[pag-1] : pag}
                                            </button>
                                    ) : (
                                        <button id={pag} key={pag} type="button" 
                                            // onClick={e => setPagina(e.target)}
                                            style={{ color: '#c88b3e' }} className="btn btn-outline" disabled>{nombreParaPaginas !== undefined ? nombreParaPaginas[pag-1] : pag}</button>
                                    )
                                ))
                            }
                            {/* {
                                paginaActiva != paginas[paginas.length - 1] ? (
                                    <button
                                        onClick={botonSiguiente}
                                        className='btn ms-2'
                                        style={{ backgroundColor: '#c88b3e', color: 'white' }}

                                    >
                                        Siguiente
                                    </button>) :
                                    (
                                        <button
                                            onClick={botonSiguiente}
                                            className='btn ms-2'
                                            style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                            disabled={true}
                                        >
                                            Siguiente
                                        </button>
                                    )
                            } */}
                        </div>
                    </div>
            </nav>
            </div>
        </Fragment>
    )
};

export default withRouter(ToolBarPaginas)
